import { Card, CardContent } from "@/components/ui/card";
import { AppEditBase } from "@/components/admin/record-load";
import { Form, useEditContext, type MutationMode } from "ra-core";

import type { Contact } from "../types";
import { ContactInputs } from "./ContactInputs";
import { FormToolbar } from "../layout/FormToolbar";
import {
  cleanupContactForEdit,
  defaultEmailJsonb,
  defaultPhoneJsonb,
} from "./contactModel";

export const ContactEdit = ({
  mutationMode,
  resource,
}: {
  mutationMode?: MutationMode;
  resource?: string;
}) => (
  <AppEditBase
    resource={resource}
    redirect={(_resource, id) => `/contacten/${id}`}
    transform={cleanupContactForEdit}
    mutationMode={mutationMode ?? "pessimistic"}
  >
    <ContactEditContent />
  </AppEditBase>
);

const normalizeContactArrayFields = (record: Contact) => ({
  ...record,
  email_jsonb:
    record.email_jsonb && record.email_jsonb.length > 0
      ? record.email_jsonb
      : defaultEmailJsonb,
  phone_jsonb:
    record.phone_jsonb && record.phone_jsonb.length > 0
      ? record.phone_jsonb
      : defaultPhoneJsonb,
});

const ContactEditContent = () => {
  const { isPending, record } = useEditContext<Contact>();
  if (isPending || !record) return null;
  return (
    <div className="mt-2 max-w-2xl">
      <Form
        className="flex flex-1 flex-col gap-4"
        record={normalizeContactArrayFields(record)}
      >
        <Card>
          <CardContent>
            <ContactInputs statusOptional />
            <FormToolbar />
          </CardContent>
        </Card>
      </Form>
    </div>
  );
};
